import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

const styles = (theme) => ({
  root: {
    margin: 0,
    borderBottom: "3px solid #007bff",
  },
  closeButton: {
    position: "absolute",
    right:'200px',
    top: '8px',
    // color: theme.palette.grey[800],
  },
});

export default function ModalNewContactUs({ open, onClose }) {
    const classes = styles();
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth style={{backgroundColor: 'rgba(0, 0, 0, 0.7)',}}>
      <MuiDialogContent  className="text-center">
        <div className='rounded my-2' style={{padding:'25px',border:"1px solid #2b84c3",boxShadow: '0px 20px 50px 0px rgba(43, 133.00000000000003, 196.00000000000003, .17)'}}>
            <IconButton aria-label="close" style={{position: 'absolute',top: '30px',right: '40px',cursor:'pointer'}} onClick={onClose}>
                <CloseIcon />
            </IconButton>
          <p className='py-1' style={{fontWeight:'700',fontSize:'16px',margin:'0px'}}>Speak with a Calque representative</p>
          <br />
          <a href="tel:5128949629" >
            <p style={{fontWeight:'800',color:' #2b85c4',marginBottom:'0px'}}className="text-primary font-weight-bold mb-0">(512) 894-9629</p>
          </a>
        </div>
        <div className=" rounded my-4 "  style={{padding:'25px',border:"1px solid #2b84c3",boxShadow: '0px 20px 50px 0px rgba(43, 133.00000000000003, 196.00000000000003, .17)'}}>
        <p className='py-1' style={{fontWeight:'700',fontSize:'16px',margin:'0px'}}>Send an email to</p>
          <br />
          <a href="mailto:info@calqueinc.com" >
            <p style={{fontWeight:'800',color:' #2b85c4',marginBottom:'0px',textDecoration:'underline'}}> info@calqueinc.com </p>
          </a>
        </div>
        <div className="rounded my-2 py-3"  style={{padding:'25px',border:"1px solid #2b84c3",boxShadow: '0px 20px 50px 0px rgba(43, 133.00000000000003, 196.00000000000003, .17)'}}>
        <p className='py-1' style={{fontWeight:'700',fontSize:'16px',margin:'0px'}}>Address</p>
          <br />
          <p style={{fontWeight:'800',color:' #2b85c4',marginBottom:'0px',paddingBottom:'5px'}}>5900 Balcones Drive #14640 Austin, TX 78731</p>
        </div>
      </MuiDialogContent>
    </Dialog>
  );
}
